import { useCallback, useState } from "react";
import { useTypedSelector } from "hooks";
import { selectIsPaymentMethodsLoading, selectPaymentMethodsData } from "features/paymentMethods/selectors";
import useActions from "features/paymentMethods/useActions";
import useSessionEffect from "hooks/useSessionEffect";
import type { PaymentMethod } from "features/paymentMethods/types";
import { stripForDuplicate } from "../PaymentMethod/PaymentMethodProvider";
import usePaymentMethodFilter from "./usePaymentMethodFilter";

const paymentMethodsEffectSymbol = Symbol('paymentMethodsEffectSymbol');

export default function usePaymentMethods() {
    const { filter, ...rest } = usePaymentMethodFilter();

    const { getAllPaymentMethods } = useActions();
    const isPaymentMethodsLoading = useTypedSelector(selectIsPaymentMethodsLoading);
    const paymentMethods = useTypedSelector(selectPaymentMethodsData());

    const [duplicateSeed, setDuplicateSeed] = useState<PaymentMethod | null>(null);

    useSessionEffect(() => {
        getAllPaymentMethods();
    }, paymentMethodsEffectSymbol);

    const getPaymentMethods = () => filter(paymentMethods);

    const requestDuplicate = useCallback((paymentMethod: PaymentMethod) => {
        setDuplicateSeed(stripForDuplicate(paymentMethod));
    }, []);

    const dismissDuplicate = useCallback(() => {
        setDuplicateSeed(null);
    }, []);

    return {
        ...rest,
        getPaymentMethods,
        isPaymentMethodsLoading,
        duplicateSeed,
        requestDuplicate,
        dismissDuplicate
    };
};
